import HotWallets from '../components/HotWallets';

const HotWalletsPage = () => {
	return <HotWallets />;
};

export default HotWalletsPage;
